import { ModulePullRequestsTableRow } from "../gql";
import { isModulePullRequestExpandable } from "../helpers";
import { ModulePullRequestsTableChildRow } from "./Cells/types";

type ModulePullRequestsTableFlatRow =
  | {
      kind: "parent";
      pullRequest: ModulePullRequestsTableRow;
      isExpandable: boolean;
      isExpanded: boolean;
    }
  | ModulePullRequestsTableChildRow;

export const flattenModulePullRequestsTableRows = (
  pullRequests: ModulePullRequestsTableRow[],
  expandedRows: Set<string>
) => {
  const rows: ModulePullRequestsTableFlatRow[] = [];
  const stickyRanges: [number, number][] = [];

  for (const pullRequest of pullRequests) {
    const isExpandable = isModulePullRequestExpandable(pullRequest.runs);
    const isExpanded = isExpandable && expandedRows.has(pullRequest.id);
    const parentIndex = rows.length;

    rows.push({ kind: "parent", pullRequest, isExpandable, isExpanded });

    if (!isExpanded) {
      continue;
    }

    pullRequest.runs.forEach((run) => {
      rows.push({ kind: "child", pullRequest, run });
    });

    stickyRanges.push([parentIndex, rows.length - 1]);
  }

  return { rows, stickyRanges };
};
